import type { FilterField } from '../fields/useFilterField'
import type { Localization } from '../types'

import React from 'react'

import {
	ControlGroup,
	ControlGroupItem,
} from '@/shared/components/ui/control-group'
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/shared/components/ui/select'

export default function ReferenceWrapper({
	filterField,
	children,
	locale,
}: {
	filterField: FilterField
	children: React.ReactNode
	locale: Localization
}) {
	const mode = filterField.getFilterMode()

	return (
		<ControlGroup className='w-full'>
			<Select value={mode} onValueChange={filterField.setFilterMode}>
				<ControlGroupItem>
					<SelectTrigger>
						<SelectValue placeholder='Mode' />
					</SelectTrigger>
				</ControlGroupItem>
				<SelectContent align='start'>
					<SelectGroup>
						<SelectItem value='reference'>
							{locale.getReferenceTypeField()}
						</SelectItem>
						<SelectItem value='value'>
							{locale.getReferenceTypeValue()}
						</SelectItem>
					</SelectGroup>
				</SelectContent>
			</Select>
			<ControlGroupItem className='w-full overflow-hidden'>
				{children}
			</ControlGroupItem>
		</ControlGroup>
	)
}
